import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import CoralButtonLink from '../shared/button/CoralButtonLink';
import createSubscribeLink from '../../utils/subscription/createSubscribeLink';
import { openUpsellAndTrackActivity } from '../../actions/dialog';
// actions
import { logSubscribeActivity } from '../../actions/logging';
import { selectExperiment } from '../../selectors/config';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';

import {
  UPSELL_GO_PREMIUM,
  UPSELL_START_FREE_TRIAL_BTN,
} from '../../constants/localizations/upsell';

import { UPSELL_CTA_TEXT } from '../../constants/experiments/upsell';
import subscribe from '../../constants/analytics/categoryActionLabel/subscribe';

const UpsellButton = ({
  source,
  dataTestId,
  buttonClassName,
  guideId,
  isExpiredWebSubscriber,
  actions,
}) => {
  const { getLocalizedText, location } = useContext(
    LocationAndLocalizationContext,
  );
  const upsellCtaText = useSelector((state) =>
    selectExperiment(state, UPSELL_CTA_TEXT),
  );
  const textKey = isExpiredWebSubscriber
    ? UPSELL_GO_PREMIUM
    : UPSELL_START_FREE_TRIAL_BTN;

  if (isExpiredWebSubscriber) {
    return (
      <CoralButtonLink
        id={`subscribe-${dataTestId}`}
        data-testid={dataTestId}
        to={createSubscribeLink({
          source,
          guideId,
          location,
        })}
        className={buttonClassName}
        label={getLocalizedText(upsellCtaText || textKey)}
        onClick={() =>
          actions.logSubscribeActivity(
            subscribe.actions.tap,
            subscribe.labels.leftsidenavUpsell,
          )
        }
      />
    );
  }

  return (
    <CoralButtonLink
      id={dataTestId}
      data-testid={dataTestId}
      className={buttonClassName}
      label={getLocalizedText(upsellCtaText || textKey)}
      onClick={() => actions.openUpsellAndTrackActivity(source, guideId)}
    />
  );
};

UpsellButton.propTypes = {
  source: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string.isRequired,
  guideId: PropTypes.string,
  isExpiredWebSubscriber: PropTypes.bool,
  actions: PropTypes.shape({
    openUpsellAndTrackActivity: PropTypes.func.isRequired,
    logSubscribeActivity: PropTypes.func.isRequired,
  }),
};

export function mapDispatchToProps(dispatch) {
  const actions = {
    openUpsellAndTrackActivity,
    logSubscribeActivity,
  };

  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(UpsellButton);
